import { createSlice } from '@reduxjs/toolkit';

export const subProductsSlice = createSlice({
	name: 'subProducts',
	initialState: {
		data: [],
	},

	reducers: {
		addSubProduct: function (state, action) {
			state.data = action.payload;
		},
	},
});

export const { addSubProduct } = subProductsSlice.actions;
export default subProductsSlice.reducer;
